'use strict';

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _objectSpread = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectSpread");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});
var defaultOptions = {
  defaultUnit: 'px',
  defaultBehavior: 'up',
  defaultBreakpointName: 'xs',
  breakpoints: {
    xs: {
      maxWidth: '575px'
    },
    sm: {
      minWidth: '576px',
      maxWidth: '767px'
    },
    md: {
      minWidth: '768px',
      maxWidth: '991px'
    },
    lg: {
      minWidth: '992px',
      maxWidth: '1199px'
    },
    xl: {
      minWidth: '1200px'
    }
  }
};

function invariant(variable, message) {
  if (!variable) {
    throw new Error(message);
  }
}

function warn(predicate, message) {
  if (!predicate) {
    console.warn(message);
  }
}

var Layout =
/*#__PURE__*/
function () {
  function Layout(options) {
    _classCallCheck(this, Layout);

    this.defaultUnit = defaultOptions.defaultUnit;
    this.defaultBehavior = defaultOptions.defaultBehavior;
    this.breakpoints = defaultOptions.breakpoints;
    this.defaultBreakpointName = defaultOptions.defaultBreakpointName;
    this.isConfigureCalled = false;
    return options ? this.configure(options, false) : this;
  }
  /**
   * Applies global layout options.
   * Make sure to call this method once, preferably on the rool level
   * of your application.
   */


  _createClass(Layout, [{
    key: "configure",
    value: function configure(options) {
      var _this = this;

      var warnOnMultiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (warnOnMultiple) {
        warn(!this.isConfigureCalled, 'Failed to configure Layout: do not call `Layout.configure()` more than once. Layout configuration must remain consistent throughout the application.');
      }

      invariant(options && typeof options === 'object', "Failed to configure Layout: expected an options Object, but got: ".concat(options, "."));
      Object.keys(options || {}).forEach(function (optionName) {
        _this[optionName] = options[optionName];
      });
      invariant(this.breakpoints, 'Failed to configure Layout: expected to have at least one breakpoint specified, but got none.');
      invariant(this.breakpoints.hasOwnProperty(this.defaultBreakpointName), "Failed to configure Layout: cannot use \"".concat(this.defaultBreakpointName, "\" as the default breakpoint (breakpoint not found)."));
      invariant(this.defaultBreakpointName, "Failed to configure Layout: expected \"defaultBreakpointName\" property set, but got: ".concat(this.defaultBreakpointName, ".")); // Mark configure method as called to prevent its multiple calls

      this.isConfigureCalled = warnOnMultiple;
      return this;
    }
  }]);

  return Layout;
}();

var Layout$1 = new Layout();
/**
 * Returns a functional composition of the given functions.
 * Applies no currying.
 */

function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (f, g) {
    return function () {
      return f(g.apply(void 0, arguments));
    };
  });
}

function isset(variable) {
  return typeof variable !== 'undefined' && variable !== null;
}

function transformNumeric(value) {
  if (!isset(value)) {
    return '';
  }
  /**
   * Suffix numeric value with the default unit.
   * Accept explicit (string) value as-is.
   *
   * When given value is zero then its generated as it is, no suffix is attached
   */


  var suffix = typeof value === 'number' && value !== 0 ? Layout$1.defaultUnit : '';
  return "".concat(value).concat(suffix);
}

var keywords = [// Dot symbol (and its sequence) is a valid placeholder,
// but not a valid CSS Grid area name.
/\.+/, // Numbers may be present in `grid-template` definition
// and describe dimensions of rows/columns.
/^[0-9]/, // Slash is a special symbol used to declare dimensions
// for columns.
'/', // "auto" is a reserved keyword to describe an automatic
// dimension value when sizing rows/columns.
'auto'];
/**
 * Determines if a given string is a valid CSS Grid area name.
 * Takes into account row/column dimensions and reserved
 * keywords used in the `grid-template` definition.
 */

function isAreaName(areaName) {
  return keywords.every(function (keyword) {
    return keyword instanceof RegExp ? !keyword.test(areaName) : areaName !== keyword;
  });
}
/**
 * Joins a given template string fragments into a valid template string.
 * Appends any row/column dimensions after the enclosing single quote
 * character to have a valid `grid-template` syntax.
 */


var joinTemplateFragments = function joinTemplateFragments(fragments) {
  var areas = [];
  var suffixes = [];
  fragments.forEach(function (areaName) {
    if (isAreaName(areaName) || /\.+/.test(areaName)) {
      areas.push(areaName);
    } else {
      suffixes.push(areaName);
    }
  }); // Wraps areas string in single quote per CSS spec

  var joinedAreas = areas.length > 0 ? "'".concat(areas.join(' '), "'") : '';
  var joinedSuffixes = suffixes.join(' '); // Ensures row/column dimensions follow areas list after its been
  // wrapped in single quotes.

  return [joinedAreas, joinedSuffixes].filter(Boolean).join(' ');
};
/**
 * Sanitizes a given `grid-template-areas` string.
 * Trims whitespaces, deduplicates quotes and wraps each line
 * in single quotes to be CSS-compliant.
 */


var sanitizeTemplateArea = compose(joinTemplateFragments, function (area) {
  return area.split(' ');
}, function (area) {
  return area.replace(/'+/gm, '');
}, function (area) {
  return area.trim();
});
var transformTemplateString = compose(function (areas) {
  return areas.join('\n');
}, function (areas) {
  return areas.map(sanitizeTemplateArea);
}, function (template) {
  return template.split('\n');
}, function (template) {
  return template.trim();
});
/**
 * Collection of prop aliases.
 * Prop alias is a prop name accepted by a component which is later
 * substituted by one or multiple CSS properties with a single value.
 * Each prop value can have a value transformer.
 */

var propAliases = {
  /* CSS Grid */
  area: {
    props: ['grid-area']
  },
  areas: {
    props: ['grid-template-areas'],
    transformValue: transformTemplateString
  },
  template: {
    props: ['grid-template'],
    transformValue: transformTemplateString
  },
  templateCols: {
    props: ['grid-template-columns']
  },
  templateRows: {
    props: ['grid-template-rows']
  },
  col: {
    props: ['grid-column']
  },
  colStart: {
    props: ['grid-column-start']
  },
  colEnd: {
    props: ['grid-column-end']
  },
  row: {
    props: ['grid-row']
  },
  rowStart: {
    props: ['grid-row-start']
  },
  rowEnd: {
    props: ['grid-row-end']
  },
  gap: {
    props: ['grid-gap'],
    transformValue: transformNumeric
  },
  gapCol: {
    props: ['grid-column-gap'],
    transformValue: transformNumeric
  },
  gapRow: {
    props: ['grid-row-gap'],
    transformValue: transformNumeric
  },
  gutter: {
    props: ['grid-gap'],
    transformValue: transformNumeric
  },
  gutterCol: {
    props: ['grid-column-gap'],
    transformValue: transformNumeric
  },
  gutterRow: {
    props: ['grid-row-gap'],
    transformValue: transformNumeric
  },
  autoRows: {
    props: ['grid-auto-rows'],
    transformValue: transformNumeric
  },
  autoCols: {
    props: ['grid-auto-columns'],
    transformValue: transformNumeric
  },
  autoFlow: {
    props: ['grid-auto-flow']
  },
  align: {
    props: ['align-self']
  },
  alignItems: {
    props: ['align-items']
  },
  alignContent: {
    props: ['align-content']
  },
  justify: {
    props: ['justify-self']
  },
  justifyItems: {
    props: ['justify-items']
  },
  justifyContent: {
    props: ['justify-content']
  },
  place: {
    props: ['place-self']
  },
  placeItems: {
    props: ['place-items']
  },
  placeContent: {
    props: ['place-content']
  },

  /* CSS Flexbox */
  flexDirection: {
    props: ['flex-direction']
  },
  flexShrink: {
    props: ['flex-shrink']
  },
  flexGrow: {
    props: ['flex-grow']
  },
  flexWrap: {
    props: ['flex-wrap']
  },

  /* Dimensions */
  height: {
    props: ['height'],
    transformValue: transformNumeric
  },
  minHeight: {
    props: ['min-height'],
    transformValue: transformNumeric
  },
  maxHeight: {
    props: ['max-height'],
    transformValue: transformNumeric
  },
  width: {
    props: ['width'],
    transformValue: transformNumeric
  },
  minWidth: {
    props: ['min-width'],
    transformValue: transformNumeric
  },
  maxWidth: {
    props: ['max-width'],
    transformValue: transformNumeric
  },

  /* Space */
  margin: {
    props: ['margin'],
    transformValue: transformNumeric
  },
  marginTop: {
    props: ['margin-top'],
    transformValue: transformNumeric
  },
  marginRight: {
    props: ['margin-right'],
    transformValue: transformNumeric
  },
  marginBottom: {
    props: ['margin-bottom'],
    transformValue: transformNumeric
  },
  marginLeft: {
    props: ['margin-left'],
    transformValue: transformNumeric
  },
  marginVertical: {
    props: ['margin-top', 'margin-bottom'],
    transformValue: transformNumeric
  },
  marginHorizontal: {
    props: ['margin-right', 'margin-left'],
    transformValue: transformNumeric
  },
  padding: {
    props: ['padding'],
    transformValue: transformNumeric
  },
  paddingTop: {
    props: ['padding-top'],
    transformValue: transformNumeric
  },
  paddingRight: {
    props: ['padding-right'],
    transformValue: transformNumeric
  },
  paddingBottom: {
    props: ['padding-bottom'],
    transformValue: transformNumeric
  },
  paddingLeft: {
    props: ['padding-left'],
    transformValue: transformNumeric
  },
  paddingVertical: {
    props: ['padding-top', 'padding-bottom'],
    transformValue: transformNumeric
  },
  paddingHorizontal: {
    props: ['padding-right', 'padding-left'],
    transformValue: transformNumeric
  }
};

function toLowerCaseFirst(str) {
  return str.slice(0, 1).toLowerCase() + str.slice(1, str.length);
}
/**
 * Returns a parsed prop summary, which includes pure prop name,
 * an optional breakpoint name and breakpoint behavior.
 *
 * \w+(?<=(sm)?(only)?)$
 * This RegExp also works well. May consider implementing once
 * lookbehind is supported everywhere.
 */


function parsePropName(originPropName) {
  var joinedBreakpointNames = Object.keys(Layout$1.breakpoints).join('|');
  var joinedBehaviors = ['down', 'only'].join('|');
  var breakpointExp = new RegExp("(".concat(joinedBreakpointNames, ")$"), 'gi');
  var behaviorExp = new RegExp("(".concat(joinedBehaviors, ")$"), 'gi');
  var behaviorMatch = originPropName.match(behaviorExp);
  var behavior = behaviorMatch ? behaviorMatch[0] : '';
  var breakpointMatch = originPropName.replace(behavior, '').match(breakpointExp);
  var breakpointName = breakpointMatch ? breakpointMatch[0] : '';
  var purePropName = originPropName.replace(breakpointName, '').replace(behavior, '');
  /**
   * Get normalized breakpoint name.
   * When a breakpoint name is a part of the prop name, covert it first letter
   * to lowercase to match the layout options. Otherwise, take the default
   * breakpoint name.
   */

  var normalizedBreakpointName = breakpointName ? toLowerCaseFirst(breakpointName) : Layout$1.defaultBreakpointName;
  var isDefaultBreakpoint = normalizedBreakpointName === Layout$1.defaultBreakpointName;
  return {
    originPropName: originPropName,
    purePropName: purePropName,
    behavior: behavior ? toLowerCaseFirst(behavior) : Layout$1.defaultBehavior,
    breakpoint: {
      name: normalizedBreakpointName,
      isDefault: isDefaultBreakpoint
    }
  };
}
/**
 * Converts given cammelCase string into kebab-case.
 * @example
 * toDashedString('fooBar')
 * @returns "foo-bar"
 */


function toDashedString(str) {
  return str.replace(/[A-Z]/g, function (capitalLetter) {
    return "-".concat(capitalLetter).toLowerCase();
  });
}
/**
 * Normalizes given media query object to a list of [propName, propValue].
 * @example
 * normalizeQuery({ minWidth: 120 })
 * // [['min-width', 120]]
 */


function normalizeQuery(queryProps) {
  return Object.entries(queryProps).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        _ = _ref2[0],
        propValue = _ref2[1];

    return isset(propValue);
  }).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        propName = _ref4[0],
        propValue = _ref4[1];

    return [toDashedString(propName), propValue];
  });
}
/**
 * Determines whether a given media query param should be added
 * to the media query string based on a breakpoint's behavior.
 */


var shouldAppendProperty = function shouldAppendProperty(queryParam, behavior) {
  var _queryParam$split = queryParam.split('-'),
      _queryParam$split2 = _slicedToArray(_queryParam$split, 2),
      prefix = _queryParam$split2[0],
      splitPropName = _queryParam$split2[1];

  var isDimensionalProp = ['height', 'width'].includes(splitPropName);

  if (!isDimensionalProp) {
    return true;
  }

  return prefix === 'min' && ['up', 'only'].includes(behavior) || prefix === 'max' && ['down', 'only'].includes(behavior);
};

var filterRelevantQueryParams = function filterRelevantQueryParams(behavior) {
  return function (queryList) {
    return queryList.filter(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
          queryParam = _ref6[0];

      return shouldAppendProperty(queryParam, behavior);
    });
  };
};
/**
 * Joins a given media query params list with the given transformer function.
 */


var joinQueryList = function joinQueryList(transformer) {
  return function (queryList) {
    return queryList.map(transformer).join(' and ');
  };
};

function createMediaQuery(breakpoint, behavior) {
  return compose(joinQueryList(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        dashedQueryProp = _ref8[0],
        propValue = _ref8[1];

    return "(".concat(dashedQueryProp, ":").concat(String(transformNumeric(propValue)), ")");
  }), filterRelevantQueryParams(behavior), normalizeQuery)(breakpoint);
}
/**
 * Generateds a single CSS string for the set of props,
 * value, and its responsive information.
 */


var createStyleString = function createStyleString(cssProps, propValue, parsedBreakpoint, behavior) {
  var styleString = cssProps.map(function (propName) {
    return "".concat(propName, ":").concat(String(propValue), ";");
  }).join(''); // Get a breakpoint dimensions based on the statically analyzed breakpoint.

  var breakpointOptions = Layout$1.breakpoints[parsedBreakpoint.name]; // Wrap CSS rule in a media query only if its prop includes
  // a breakpoint and behavior different from the default ones.

  var shouldWrapInMediaQuery = breakpointOptions && !(parsedBreakpoint.isDefault && behavior === Layout$1.defaultBehavior);
  return shouldWrapInMediaQuery ? "@media ".concat(createMediaQuery(breakpointOptions, behavior), " {").concat(styleString, "}") : styleString;
};
/**
 * Transforms known prop aliases to CSS rules for the given props.
 */


function applyStyles(pristineProps) {
  return Object.keys(pristineProps) // Parse each prop to include "breakpoint" and "behavior"
  .map(parsePropName) // Filter out props that are not included in prop aliases
  .filter(function (_ref9) {
    var purePropName = _ref9.purePropName;
    return propAliases.hasOwnProperty(purePropName);
  }) // Filter out props with "undefined" or "null" as value
  .filter(function (_ref10) {
    var originPropName = _ref10.originPropName;
    return isset(pristineProps[originPropName]);
  }) // Map each prop to a CSS rule string
  .map(function (_ref11) {
    var purePropName = _ref11.purePropName,
        originPropName = _ref11.originPropName,
        breakpoint = _ref11.breakpoint,
        behavior = _ref11.behavior;
    var _propAliases$pureProp = propAliases[purePropName],
        props = _propAliases$pureProp.props,
        transformValue = _propAliases$pureProp.transformValue;
    var propValue = pristineProps[originPropName];
    var transformedPropValue = transformValue ? transformValue(propValue) : propValue;
    return createStyleString(props, transformedPropValue, breakpoint, behavior);
  }).join(' ');
}

var createWithBreakpoints = function createWithBreakpoints(breakpoints) {
  var existingBreakpoints = Object.keys(breakpoints);
  return function (breakpointsMap, defaultValue) {
    var breakpointMatch = Object.keys(breakpointsMap).filter(function (breakpointName) {
      var hasBreakpoint = existingBreakpoints.includes(breakpointName);

      if (!hasBreakpoint) {
        console.warn('useBreakpoints: Breakpoint "%s" is not found. Add it via "Layout.configure()", or use one of the existing breakpoints (%s).', breakpointName, existingBreakpoints.join(', '));
      }

      return hasBreakpoint;
    }).find(function (breakpointName) {
      var breakpoint = breakpoints[breakpointName];
      var mediaQuery = createMediaQuery(breakpoint, 'only');
      return breakpoint && matchMedia(mediaQuery).matches;
    });
    return breakpointMatch ? breakpointsMap[breakpointMatch] : defaultValue;
  };
};

var withBreakpoints = createWithBreakpoints(Layout$1.breakpoints);

function getPrefix(str) {
  var prompt = str.match(/^(min|max)/);
  return prompt ? prompt[0] : '';
}
/**
 * Opens the given breakpoint.
 * A breakpoint is considered open when it has no upper boundary. For example,
 * a breakpoint that has "maxWidth: undefined" is the open breakpoint.
 */


function openBreakpoint(breakpoint) {
  return Object.keys(breakpoint).reduce(function (acc, key) {
    return _objectSpread({}, acc, _defineProperty({}, key, getPrefix(key) === 'max' ? undefined : breakpoint[key]));
  }, {});
}
/**
 * Accepts a breakpoint and returns a new breakpoint where
 * all the "min" properties of the original breakpoint are
 * flipped into the "max" properties. Any "max" properties
 * of the original breakpoint are omitted.
 * Subtracts 1 from the numeric values of all "min" properties
 * to not overlap with the given breakpoint.
 *
 * @example
 * flipBreakpoint({ minWidth: 500, maxWidth: 600 })
 * // { maxWidth: 499 }
 */


function flipBreakpoint(breakpoint) {
  return Object.entries(breakpoint).map(function (_ref12) {
    var _ref13 = _slicedToArray(_ref12, 2),
        propName = _ref13[0],
        propValue = _ref13[1];

    return [getPrefix(propName), propName, propValue];
  }).filter(function (_ref14) {
    var _ref15 = _slicedToArray(_ref14, 1),
        prefix = _ref15[0];

    return prefix !== 'max';
  }).reduce(function (newBreakpoint, _ref16) {
    var _ref17 = _slicedToArray(_ref16, 3),
        prefix = _ref17[0],
        propName = _ref17[1],
        propValue = _ref17[2];

    var hasMinPrefix = prefix === 'min';
    var nextPropName = hasMinPrefix ? propName.replace(/^min/, 'max') : propName; // Parse a breakpoint property value into a numeric value
    // and its measurement unit.

    var _$exec = /(\d+)(.+)?/.exec(propValue),
        _$exec2 = _slicedToArray(_$exec, 3),
        numericValue = _$exec2[1],
        unit = _$exec2[2];
    /**
     * Subtracts 1 from the edge to not include the area at the beginning
     * of the breakpoint.
     *
     * @todo
     * How is "parseFloat" going to work with non-dimensional options?
     * (i.e. aspectRatio)
     */


    var nextNumericValue = hasMinPrefix ? parseFloat(numericValue) - 1 : numericValue; // Append back the measurement unit.
    // Prevents breakpoints like { "minWidth": "768px" }
    // becoming { "minWidth": 768 } -> { "minWidth": "768rem" }
    // when the measurement unit is not "px".

    var nextValue = unit ? "".concat(nextNumericValue).concat(unit) : nextNumericValue;
    return _objectSpread({}, newBreakpoint, _defineProperty({}, nextPropName, nextValue));
  }, {});
}
/**
 * Merges two given area records.
 */


function mergeAreaRecords(nextAreaRecord, prevAreaRecord, includesArea) {
  var prevRecordBehavior = prevAreaRecord.behavior;
  var nextRecordBehavior = nextAreaRecord.behavior;
  var wentUp = prevRecordBehavior === 'up';
  var goesDown = nextRecordBehavior === 'down';
  var behavesSame = prevRecordBehavior === nextRecordBehavior;
  var behavesInclusive = wentUp && goesDown;
  var shouldStretch = wentUp;
  var nextBehavior = !includesArea && shouldStretch ? 'down' : nextRecordBehavior;

  var mergedBreakpoint = _objectSpread({}, prevAreaRecord.breakpoint, nextAreaRecord.breakpoint);

  var nextBreakpoint = Object.keys(mergedBreakpoint).reduce(function (acc, propName) {
    var nextValue = mergedBreakpoint[propName];
    var prefix = getPrefix(propName);

    if (prefix === 'max') {
      if (!includesArea && shouldStretch) {
        var reversedValue = nextAreaRecord.breakpoint[propName.replace(/^max/, 'min')];
        nextValue = "calc(".concat(transformNumeric(reversedValue), " - 1px)");
      }
    }

    if (prefix === 'min') {
      if (includesArea) {
        if (behavesSame || behavesInclusive) {
          nextValue = prevAreaRecord.breakpoint[propName];
        }
      } else {
        if (shouldStretch) {
          nextValue = prevAreaRecord.breakpoint[propName];
        }
      }
    }

    return _objectSpread({}, acc, _defineProperty({}, propName, nextValue));
  }, {});
  return {
    behavior: nextBehavior,
    breakpoint: nextBreakpoint
  };
}
/**
 * Returns an array of unique normalized grid area names
 * from the given template string. Any member of the returned list
 * is later evolved into a React component.
 */


var sanitizeTemplateString = compose(function (list) {
  return list.sort();
}, // Deduplicate area strings
function (list) {
  return Array.from(new Set(list));
}, // Filter out "template" row/columns sizes
function (arr) {
  return arr.filter(isAreaName);
}, // Filter out empty area strings
function (arr) {
  return arr.filter(Boolean);
}, // Split into a list of areas
function (str) {
  return str.split(' ');
}, // Deduplicate multiple spaces
function (str) {
  return str.replace(/\s+/g, ' ');
}, // Replace new lines and single quotes with spaces
function (str) {
  return str.replace(/\r?\n|\'+/g, ' ');
});
/**
 * Accepts a props object and filters it to include
 * only template-related prop:value pairs.
 */

var filterTemplateProps = function filterTemplateProps(props) {
  return Object.keys(props).filter(function (propName) {
    var _parsePropName = parsePropName(propName),
        purePropName = _parsePropName.purePropName;

    return ['areas', 'template'].includes(purePropName);
  }).reduce(function (acc, propName) {
    return _objectSpread({}, acc, _defineProperty({}, propName, sanitizeTemplateString(props[propName])));
  }, {});
};

function getAreasList(templateProps) {
  var areasList = Object.entries(templateProps).reduce(function (acc, _ref18) {
    var _ref19 = _slicedToArray(_ref18, 2),
        templateName = _ref19[0],
        templateAreas = _ref19[1];

    var _parsePropName2 = parsePropName(templateName),
        breakpoint = _parsePropName2.breakpoint,
        behavior = _parsePropName2.behavior;

    var nextAreas = acc.areas.concat(templateAreas);
    var nextTemplates = acc.templates.concat({
      breakpoint: Layout$1.breakpoints[breakpoint.name],
      behavior: behavior,
      areas: templateAreas
    });
    return {
      areas: nextAreas,
      templates: nextTemplates
    };
  }, {
    areas: [],
    templates: []
  });
  var areas = areasList.areas,
      templates = areasList.templates;
  return {
    areas: Array.from(new Set(areas)),
    templates: templates
  };
}

function memoizeWith(saltGenerator) {
  var cache = {};
  return function (func) {
    return function () {
      var key = saltGenerator.apply(void 0, arguments);

      if (!(key in cache)) {
        cache[key] = func.apply(void 0, arguments);
      }

      return cache[key];
    };
  };
}

function hashString(str) {
  var length = str.length;
  var hash = 0;
  var i = 0;

  if (length > 0) {
    while (i < length) {
      hash = (hash << 5) - hash + str.charCodeAt(i++) | 0;
    }
  }

  return hash;
}
/**
 * Memoize areas generation based on the sanitized "templateProp:areas" pairs.
 * Alphabetical sorting of incoming template areas allows reproducible cache keys.
 * @todo `pairs` is an empty array sometimes. Should we handle it somehow?
 */


var memoizeProps = memoizeWith(function (templateProps) {
  var pairs = Object.entries(templateProps).reduce(function (acc, _ref20) {
    var _ref21 = _slicedToArray(_ref20, 2),
        propName = _ref21[0],
        templateAreas = _ref21[1];

    return acc.concat("".concat(propName, ":").concat(templateAreas.join()));
  }, []);
  return hashString(pairs.join()).toString();
});
/**
 * Parses a given map of props and returns an areas map.
 */

var parseTemplates = compose(memoizeProps(getAreasList), filterTemplateProps);

function capitalize(str) {
  return str.replace(/^./, function (firstLetter) {
    return firstLetter.toUpperCase();
  });
}
/**
 * Returns the shallow copy of the given array with
 * the last element removed.
 */


function pop(list) {
  return list.slice(0, list.length - 1);
}
/**
 * Replaces the prefixes in a parameter name.
 * Allows strict comparison of same parameters with different prefixes.
 * Does not test for inclusion/notch.
 *
 * @example
 * neutralizeParamName('maxWidth') // "_width"
 * neutralizeParamName('minWidth') // "_width"
 */


var neutralizeParamName = function neutralizeParamName(paramName) {
  return paramName.replace(/^min|max/, '_');
};
/**
 * Determines whether two given breakpoints can be merged.
 * Assures non-compatible breakpoints are not prompted to
 * be merged during the area params composition.
 */


function shouldCombineBreakpoints(breakpointA, breakpointB) {
  var allParams = Object.keys(breakpointA).concat(Object.keys(breakpointB));
  return allParams.every(function (pristineParamName, index) {
    var paramName = neutralizeParamName(pristineParamName);
    var prevParamName = neutralizeParamName(allParams[index - 1] || paramName);
    return paramName === prevParamName;
  });
}

var canMergeRecords = function canMergeRecords(prevRecord, nextRecord) {
  var hasSameBehavior = prevRecord.behavior === nextRecord.behavior;
  var hasInclusiveBehavior = prevRecord.behavior === 'up' && nextRecord.behavior === 'down';
  var shouldMergeRecords = hasSameBehavior || hasInclusiveBehavior;

  if (!shouldMergeRecords) {
    return false;
  } // Check if breakpoints are compatible to be merged


  return shouldCombineBreakpoints(prevRecord.breakpoint, nextRecord.breakpoint);
};

var handleLastRecord = function handleLastRecord(isLastTempate, areaRecord) {
  return {
    behavior: areaRecord.behavior,
    breakpoint: isLastTempate && areaRecord.behavior === 'up' ? openBreakpoint(areaRecord.breakpoint) : areaRecord.breakpoint
  };
};

function getAreaRecords(areaName, templates) {
  var templatesCount = templates.length;
  return templates.reduce(function (list, template, index) {
    var areas = template.areas,
        behavior = template.behavior,
        breakpoint = template.breakpoint; // Important to know if operating on the last record
    // to properly construct the trailing breakpoint.

    var isLastTempate = index === templatesCount - 1;
    var includesArea = areas.includes(areaName);
    var areaRecord = {
      breakpoint: breakpoint,
      behavior: behavior
    };
    var lastAreaRecord = list[list.length - 1];

    if (includesArea) {
      var shouldMergeRecords = lastAreaRecord && canMergeRecords(lastAreaRecord, areaRecord);

      if (shouldMergeRecords) {
        var mergedAreaRecord = mergeAreaRecords(areaRecord, lastAreaRecord, includesArea); // Replace the preceding area record with the merged instance.

        return pop(list).concat(handleLastRecord(isLastTempate, mergedAreaRecord));
      } // Append the new area record.


      return list.concat(handleLastRecord(isLastTempate, areaRecord));
    } // When the area is not present in the current template
    // check if the preceding area record exists. If so,
    // make sure to close it to prevent it from rendering on this breakpoint.


    if (lastAreaRecord) {
      /**
       * @todo Confusing that "merge" also closes the breakpoint.
       * Also it needs prev and next. Uh.
       */
      var closedLastAreaRecord = mergeAreaRecords(areaRecord, lastAreaRecord, includesArea);
      return pop(list).concat([closedLastAreaRecord, null]);
    } // Appending explicit "null" creates a separation between breakpoints
    // that prevents them being treated like siblings. Breakpoints separated
    // by "null" are not attempted to be merged, or analyzed together in any way.


    return list.concat(null);
  }, []);
}
/**
 * Returns a map of React components based on the given grid areas
 * in the given template definitions.
 */


function generateComponents(_ref22, createAreaComponent, withPlaceholder) {
  var areas = _ref22.areas,
      templates = _ref22.templates;
  var componentsMap = areas.reduce(function (components, areaName) {
    var areaRecords = getAreaRecords(areaName, templates);
    var areaBreakpoints = areaRecords.filter(Boolean).map(function (areaRecord) {
      return areaRecord.breakpoint;
    });
    var shouldAlwaysRender = areaRecords.length === 1 && areaBreakpoints.every(function (breakpoint) {
      return !breakpoint.minWidth && !breakpoint.maxWidth;
    });
    var Component = createAreaComponent(areaName);
    var capitalizedAreaName = capitalize(areaName);
    Component.displayName = capitalizedAreaName;
    var ResponsiveComponent = shouldAlwaysRender ? Component : withPlaceholder(Component, areaBreakpoints);
    return _objectSpread({}, components, _defineProperty({}, capitalizedAreaName, ResponsiveComponent));
  }, {}); // Return plain components map for browsers that don't support Proxy.
  // Requires safety check before rendering conditional areas.

  return typeof Proxy === 'undefined' ? componentsMap : new Proxy(componentsMap, {
    get: function get(components, areaName) {
      if (areaName in components || typeof areaName === 'symbol') {
        return components[areaName];
      } // Replace non-existing area component with
      // the dummy component that renders nothing.
      // This prevents from the exception when rendering "undefined"
      // and allows dynamic runtime template areas.


      return function () {
        return null;
      };
    }
  });
}
/**
 * Throttles a given function.
 * Implements both leading and trailing function calls.
 */


function throttle(func, interval) {
  var previous;
  var queuedToRun = null;
  return function invoker() {
    var now = Date.now();
    clearTimeout(queuedToRun);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    if (!previous || now - previous >= interval) {
      func.apply(null, args);
      previous = now;
    } else {
      queuedToRun = setTimeout(invoker.bind.apply(invoker, [null].concat(args)), interval - (now - previous));
    }
  };
}

exports.Layout = Layout$1;
exports.applyStyles = applyStyles;
exports.closeBreakpoint = flipBreakpoint;
exports.compose = compose;
exports.createMediaQuery = createMediaQuery;
exports.defaultOptions = defaultOptions;
exports.generateComponents = generateComponents;
exports.joinQueryList = joinQueryList;
exports.mergeAreaRecords = mergeAreaRecords;
exports.normalizeQuery = normalizeQuery;
exports.openBreakpoint = openBreakpoint;
exports.parsePropName = parsePropName;
exports.parseTemplates = parseTemplates;
exports.propAliases = propAliases;
exports.throttle = throttle;
exports.transformNumeric = transformNumeric;
exports.warn = warn;
exports.withBreakpoints = withBreakpoints;